import { useEffect, type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, type BoxProps, useIsMobileVariant } from '@dhl-ui/components'
import { useDismissableMaintenanceMessages, usePrismicMaintenanceMessage } from '../model/hooks.js'
import { type MaintenanceMessageItem, type MaintenanceTags } from '../model/maintenance.js'
import { MaintenanceAlert } from './MaintenanceAlert.js'

type Props = {
  prismicEndpoint: string
  tag: MaintenanceTags
  isRefreshing?: boolean
} & Partial<Pick<BoxProps, 'sx'>>

export const MaintenanceMessage: FC<Props> = ({ prismicEndpoint, tag, isRefreshing, sx }) => {
  const { i18n } = useTranslation()
  const isMobileVariant = useIsMobileVariant()

  const { data: maintenanceMessage, refetch } = usePrismicMaintenanceMessage(
    prismicEndpoint,
    tag,
    i18n?.language,
    isMobileVariant
  )

  const { isMessageDismissed, dismissMessage } = useDismissableMaintenanceMessages()

  useEffect(() => {
    if (isRefreshing) {
      refetch()
    }
  }, [isRefreshing, refetch])

  const handleDismiss = (item: MaintenanceMessageItem) => dismissMessage(tag, item.id, item.lastPublicationDate)

  if (
    !maintenanceMessage ||
    isMessageDismissed(tag, maintenanceMessage.id, maintenanceMessage.lastPublicationDate) ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).Cypress
  ) {
    return null
  }

  return (
    <Box sx={sx}>
      <MaintenanceAlert item={maintenanceMessage} onDismiss={handleDismiss} />
    </Box>
  )
}
